/* src/app/components/lead-details/tax-documents/tax-documents.component.css */
::ng-deep .ant-radio-group {
  display: block;
}
.retirement-history-action {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
/*# sourceMappingURL=tax-documents.component-OKVEY267.css.map */
